import React, { useState, useEffect } from 'react'
import Icon from '../icon'
import Switch from '../../baseComponent/switch'
import LazyLoadImage from '../../baseComponent/lazyLoadImage'
import { ROLE_COMPARISON } from '../enum'
import request from '../../utils/request'
import './cooperation.less'

/**
 * @description: 子灵感集协作设置组件（因显示跟灵感集不同，故重写）
 * @return {*}
 */
const childCooperation = (props) => {
  const { id, parentId, onChange, setLoading } = props
  const [allUsers, setAllUsers] = useState([])
  useEffect(() => {
    fetchAllUsers()
  }, [])
  const fetchAllUsers = async () => {
    setLoading?.(true)
    try {
      const res = await request.sget('/zhikuan/ins/inspiration/auth/cooperation-user-list', { inspirationId: id, parentId }, 'MN_fetchAllUsers')
      setAllUsers(() => { onChange?.(res); return res })
    } catch (err) {
      console.error('cooperation-user-list', err)
    }
    setLoading?.(false)
  }

  const updateUserStatus = async (users) => {
    try {
      await request.post('/zhikuan/ins/inspiration/auth/update-inspiration-user', { inspirationId: id, users })
    } catch (err) {
      console.error(err)
    } finally {
      fetchAllUsers()
    }
  }
  return (
    <div className="mn-child-cooperation">
      <div className="cooperation-members">
        {
          allUsers?.length > 0 && allUsers?.map(user => <div className="member-item">
            <div className="item-left">
              <div className="user-item-img">
                <LazyLoadImage src={user.avatar} />
              </div>
              <div className="user-item-name">{user.nickName}</div>
              <div className="user-item-role">{ROLE_COMPARISON[user.role]}</div>
            </div>
            <div className="item-right">
              <Switch
                disabled={!user.roleInheritOperateAccess}
                active={user.roleInherit}
                onChange={(val) => {
                  const users = allUsers.map(item => {
                    if (item.userId === user.userId) {
                      return {
                        ...item,
                        roleInherit: val
                      }
                    }
                    return item
                  })
                  id && updateUserStatus(users?.filter(item => item.roleInherit === true).map(i => { return { role: i.role, userId: i.userId } }))
                  setAllUsers(users)
                  onChange?.(users)
                }}
              />
            </div>
          </div>)
        }
      </div>
      <div className="cooperation-tip">
        <Icon type="m-jinggao" style={{ fontSize: 16, marginRight: 4 }} />
        <span>子灵感集只能设置是否允许该成员访问</span>
      </div>
    </div>
  )
}

export default childCooperation
